module.exports = {
  _getValueFromPath: function (context, path) {
    var obj = context
    var stack = path.split('.')
    while (stack.length) {
      obj = obj[stack.shift()]
    }
    return obj
  },
  safe: function (object, path, def) {
    try {
      return this._getValueFromPath(object, path)
    } catch (e) {
      if (def) return def
      return ''
    }
  },
  capitalize: function (word) {
    return word[0].toUpperCase() + word.slice(1).toLowerCase()
  },
  nullToEmpty: function (text) {
    if (text === 'null' || text === 'undefined' || !text) return ''
    return text
  }
}



// WEBPACK FOOTER //
// ./src/helpers/string.js